<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h3>Add New Service</h3>
      <AddElement category_id="2"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewService",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Services',
          to: '/services/all'
        }, {
          text: 'Add Service',
          href: '#'
        }
      ],
    };
  },
};
</script>